import React from 'react';
import { DossiersContainer } from './dossiers';
export const DocReqMain = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(DossiersContainer, null)));
};
